import {
  MobileButton,
  StyledLineOne,
  StyledLineSecond,
} from "./MobileHeaderStyle";

export const MobileMenuButton = ({
  showMenu,
  setShowMenu,
}: {
  showMenu: boolean;
  setShowMenu: Function;
}) => {
  return (
    <MobileButton
      data-testid="mobile-menu-button"
      onClick={() => setShowMenu(!showMenu)}
    >
      <StyledLineOne showMenu={showMenu}></StyledLineOne>
      <StyledLineSecond showMenu={showMenu}></StyledLineSecond>
    </MobileButton>
  );
};
